// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css'; // Global CSS
import './aws-config';
import App from './App';

console.log('Cinesplat v.1.8');

// Covers a page reload/direct load while an active share session is stashed
// (SharedScene.js sets this same class before its first navigate) — applied
// here, synchronously, before anything renders, so the shared-view CSS is
// already active by the time any admin-only controls mount.
if (sessionStorage.getItem('shareToken')) {
  document.body.classList.add('shared-view');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
